import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FGrid } from '../grid';
import { ForecastMoneyCell, ForecastVarianceCell, ForecastPercentCell, ForecastConfidenceCell, ForecastStatusChip, ForecastDeltaClass, ForecastGridSx } from './ForecastGridRenderers';

type Props = { rows:any[]; loading?:boolean; selectedId?:any; onSelect?:(row:any)=>void };

class ForecastFactGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'datasetcode', headerName: 'Dataset', width: 140 },
    { field: 'productcode', headerName: 'Product', width: 130 },
    { field: 'metriccode', headerName: 'Metric', width: 150 },
    { field: 'periodcode', headerName: 'Period', width: 120 },
    { field: 'locationcode', headerName: 'Location', width: 130 },
    { field: 'quantity', headerName: 'Quantity', width: 130, type: 'number' },
    { field: 'unitprice', headerName: 'Unit Price', width: 130, renderCell: ForecastMoneyCell },
    { field: 'amount', headerName: 'Amount', width: 150, renderCell: ForecastMoneyCell },
    { field: 'sourcecell', headerName: 'Source Cell', width: 120 },
    { field: 'lineage', headerName: 'Lineage', width: 260, flex: 1, minWidth: 260 },
  ];

  getRowId = (row:any) => row.rid || row.recid || row.id || `${row.batchcode}-${row.datasetcode}-${row.productcode}-${row.metriccode}-${row.periodcode}-${row.locationcode}-${row.sourcecell}`;

  render() {
    return (
      <FGrid
        title="Forecast Facts"
        subtitle="Normalized fact records extracted from forecast workbooks."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={480}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#e7f6ea' }}
        getRowId={this.getRowId}
        onRowClick={(p: any) => this.props.onSelect?.(p.row)}
        pageSizeOptions={[25, 50, 100]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
        sx={ForecastGridSx}
      />
    );
  }
}

export default ForecastFactGrid;
